import React from 'react';

interface MetricCardProps {
  title: string;
  iconBg: string;
  iconColor: string;
  icon: React.ReactNode;
  loading?: boolean;
  error?: boolean;
  value: React.ReactNode;
  subtitle?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({ title, iconBg, iconColor, icon, loading, error, value, subtitle }) => (
  <div
    style={{
      background: '#fff',
      borderRadius: 12,
      padding: 24,
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <span style={{ fontSize: 14, color: '#6b7280', fontWeight: 500 }}>{title}</span>
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: 10,
          background: iconBg,
          color: iconColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon}
      </div>
    </div>
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
      {loading ? (
        <span style={{ fontSize: 36, fontWeight: 700, color: '#d1d5db' }}>-</span>
      ) : error ? (
        <span style={{ fontSize: 36, fontWeight: 700, color: '#ef4444' }}>!</span>
      ) : (
        value
      )}
    </div>
    {subtitle && (
      <p style={{ fontSize: 12, color: '#9ca3af', margin: 0, lineHeight: 1.4 }}>{subtitle}</p>
    )}
  </div>
);

export default MetricCard;
